
import { type localStorageFilterType } from "./FilterManager";

export interface FilterManagerIOType {
    load(): Promise<localStorageFilterType>;
    save(data: localStorageFilterType): Promise<void>;
}

export class FilterManagerIO implements FilterManagerIOType {

    public load: () => Promise<localStorageFilterType>;
    public save: (data: localStorageFilterType) => Promise<void>;

    constructor(load: () => Promise<localStorageFilterType>,
                save: (data: localStorageFilterType) => Promise<void>) {
        this.load = load;
        this.save = save;
    }

}